<template>
    <div :class="['sms-verification', className]">
        <!-- 验证码输入框插槽 -->
        <slot name="input">
            <input type="text" v-model="localKeyCode" @input="updateKeyCode" placeholder="请输入短信验证码">
        </slot>
        <!-- 发送验证码按钮 -->
        <span class="getKeyCode" @click="showVerification" v-show="isShowKeyCode">
            发送验证码
        </span>
        <!-- 倒计时显示 -->
        <span class="time" v-show="!isShowKeyCode">{{ time }}s</span>

        <!-- 蒙层 -->
        <div v-if="showModal" class="modal-overlay" @click="closeModal"></div>
        <!-- 验证弹窗 -->
        <div v-if="showModal" class="verify-modal">
            <div class="modal-header">
                <h3>请输入验证码，完成验证</h3>
                <div class="el-icon-close close-btn" @click="closeModal"></div>
            </div>
            <div class="modal-body">
                <captcha mode="text" resolve="text" :callSuccess="onSuccess" />
                <div class="tips">刷新验证码 | 显示输入框</div>
            </div>
        </div>
    </div>
</template>

<script>
import Captcha from 'vue-captcha';

// 短信验证码组件
export default {
    name: 'SmsVerification',
    components: {
        Captcha
    },
    props: {
        phone: { // 手机号
            type: String,
            required: true
        },
        keyCode: { // 验证码输入值
            type: String,
            required: true
        },
        isShowKeyCode: { // 是否显示发送按钮
            type: Boolean,
            default: true
        },
        time: { // 倒计时时间（秒）
            type: Number,
            default: 60
        },
        className: { // 外部传入的类名
            type: String,
            default: ''
        }
    },
    data() {
        return {
            showModal: false, // 是否显示验证弹窗
            localKeyCode: this.keyCode // 本地存储验证码输入值
        }
    },
    watch: {
        // 监听keyCode prop的变化，同步到本地变量
        keyCode: {
            handler(newVal) {
                this.localKeyCode = newVal;
            },
            immediate: true
        }
    },
    methods: {
        // 显示验证弹窗
        showVerification() {
            // 验证手机号格式
            var reg = /(^1[123456789]\d{9}$)|(^\d{8}$)/;
            if (!reg.test(this.phone)) {
                this.$message({
                    message: '请输入正确的手机号',
                    type: 'error'
                });
                return;
            }
            this.showModal = true;
        },

        // 关闭验证弹窗
        closeModal() {
            this.showModal = false;
        },

        // 验证成功回调
        onSuccess() {
            this.showModal = false;
            this.$message({
                message: '验证成功',
                type: 'success'
            });
            this.$emit('sendCode');
        },

        // 更新keyCode值并通知父组件
        updateKeyCode() {
            this.$emit('update:keyCode', this.localKeyCode);
        }
    }
}
</script>

<style scoped lang="less">
.sms-verification {
    position: relative;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    input {
        border: none;
        min-width: calc(100% - 120px);
        height: 42px;
        width: 312px;
        line-height: 52px;
        display: inline-block;
        border-radius: 4px;
        outline: none;
        text-indent: 24px;
        background: rgba(36, 130, 243, 0.1);
        border-radius: 4px;
        border: 1px solid rgba(25, 122, 239, 0.3);
    }

    .getKeyCode {
        text-align: center;
        font-size: 14px;
        line-height: 42px;
        position: absolute;
        right: 0;
        top: 0px;
        cursor: pointer;
        width: 104px;
        height: 42px;
        background: linear-gradient(270deg, #0B71EB 0%, #3D93FA 100%);
        border-radius: 4px;
        color: #fff;
        border: 1px solid rgba(25, 122, 239, 0.3);
    }

    .time {
        text-align: center;
        font-size: 14px;
        line-height: 42px;
        position: absolute;
        right: 0;
        top: 0px;
        cursor: pointer;
        width: 104px;
        height: 42px;
        background: #ccc;
        border-radius: 4px;
        color: #fff;
        border: 1px solid #ccc;
    }
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
}

.verify-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    width: 350px;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    border-bottom: 1px solid #eaeaea;

    h3 {
        margin: 0;
        font-size: 16px;
        font-weight: bold;
        color: #333;
    }

    .close-btn {
        font-size: 20px;
        cursor: pointer;
        color: #999;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
            color: #333;
        }
    }
}

.modal-body {
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    ::v-deep .vue-captcha .content-text>input {
        font-size: 20px;
    }

    .tips {
        font-size: 12px;
        color: #999;
        margin-top: 8px;
        line-height: 1;
    }
}
</style>